import React from 'react'
import cn from 'classnames'
import { observer } from 'mobx-react'

import TabStore from 'stores/tab/TabStore'
import TelemetryStore from 'stores/telemetry/TelemetryStore'

import Button from 'components/button/Button'
import WhereFilter from 'components/databrowserFilters/WhereFilter'
import FieldFilter from 'components/databrowserFilters/FieldFilter'
import PaginationFilter from 'components/databrowserFilters/PaginationFilter'
import PendingActions from 'components/pendingActions/PendingActions'
import Results from 'components/results/Results'
import Refresh from 'assets/icons/refresh.svg'

import styles from './databrowser.scss'

export type IViewMode = 'table' | 'tree'

interface IProps {}

class Databrowser extends React.PureComponent<IProps> {
  results: React.RefObject<any> = React.createRef()

  handleCreateRecord = () => {
    TabStore.activeTab?.session?.createUncommittedRecord()
    TelemetryStore.send({
      command: 'record_create',
      commandDetails: {},
    })
  }

  handleDeleteRecords = () => {
    this.results.current.deleteSelectedRows()
    this.results.current.selectRows([])
    this.results.current.focus()
  }

  handleSuccess = () => {
    this.results.current.selectRows([])
    this.results.current.focus()
    this.results.current.refresh()
  }

  render() {
    const session = TabStore.activeTab?.session

    if (!session || !session?.isScript) {
      return null
    }

    return (
      <div className={styles.container} data-cy="databrowser">
        <div className={styles.header}>
          <Button
            className={cn(styles.refreshBtn, {
              [styles.spin]: session.script!.running,
            })}
            disabled={session.script!.running}
            onClick={() => session.script.run()}
          >
            <Refresh />
          </Button>
          <WhereFilter />
          <FieldFilter />
          <PaginationFilter />
          <div className={styles.separator} />
          <Button
            data-cy="create-record-btn"
            onClick={this.handleCreateRecord}
            disabled={session.isScript && session.script.viewMode === 'tree'}
          >
            Add record
          </Button>
          {session.selection.table.selectedRecordIds.length > 0 && (
            <Button
              data-cy="delete-record-btn"
              className={styles.deleteBtn}
              onClick={this.handleDeleteRecords}
            >
              <>
                Delete {session.selection.table.selectedRecordIds.length} record
                {session.selection.table.selectedRecordIds.length > 1
                  ? 's'
                  : ''}
              </>
            </Button>
          )}

          <PendingActions
            className={styles.pendingActions}
            onSuccess={this.handleSuccess}
          />
        </div>

        <Results
          ref={this.results}
          className={styles.results}
          width={window.innerWidth}
          height={
            window.innerHeight -
            36 /* Height of the header */ -
            44 /* Height of the filters bar */
          }
        />
      </div>
    )
  }
}

export default observer(Databrowser)
